export function registerServiceWorker() {
  const enabled = process.env.NODE_ENV === "production" || process.env.REACT_APP_ENABLE_PWA === "true";
  if (!("serviceWorker" in navigator) || !enabled) return;

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js");

      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("fpb:pwa-update-ready"));
          }
        });
      });
    } catch (error) {
      console.warn("Service worker registration failed:", error);
    }
  });
}
